import { render } from "./MetawebSelectDialog.vue?vue&type=template&id=0e2c4f3c&ts=true"
import script from "./MetawebSelectDialog.vue?vue&type=script&lang=ts"
export * from "./MetawebSelectDialog.vue?vue&type=script&lang=ts"

import "./MetawebSelectDialog.vue?vue&type=style&index=0&id=0e2c4f3c&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__